import { useSelector } from 'react-redux';
import ChatHistoryButton from './components/web/ChatHistoryButton';
import { isChatHistoryButtonEnabled } from './functions';
const chatHistory = {
    key: 'chat-history',
    Content: ChatHistoryButton,
    group: 3
};
/**
 * Hook for getting the chat history button.
 *
 * @returns {Object|undefined} The chat history button if it's enabled, undefined otherwise.
 */
export function useChatHistoryButton() {
    const chatHistoryButtonEnabled = useSelector(isChatHistoryButtonEnabled);
    if (chatHistoryButtonEnabled) {
        return chatHistory;
    }
}
